// components/InlinePdfUpload.jsx
import React from "react";
import { Upload, Button, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

/**
 * InlinePdfUpload
 * Props:
 *  - fileList: controlled antd Upload fileList (array)
 *  - onChange: (newFileList) => void
 *  - maxCount?: number
 *  - buttonText?: string
 *  - disabled?: boolean
 */
export default function InlineUpload({
  fileList = [],
  onChange,
  maxCount = 10,
  buttonText = "Upload",
  disabled = false,
}) {
  const beforeUpload = (file) => {
    // Accept only PDFs
    const isPdf =
      file.type === "application/pdf" ||
      /\.pdf$/i.test(file.name);
    if (!isPdf) {
      message.error("Only PDF files are allowed.");
    }
    return false; // prevent auto upload
  };

  const handleChange = ({ fileList: next }) => {
    // Enforce maxCount
    const trimmed = next.slice(0, maxCount);
    onChange?.(trimmed);
  };

  const removeAt = (idx) => {
    const copy = [...fileList];
    copy.splice(idx, 1);
    onChange?.(copy);
  };

  return (
    <div>
      <Upload
        multiple
        accept=".pdf,application/pdf"
        showUploadList={false}
        fileList={fileList}
        beforeUpload={beforeUpload}
        onChange={handleChange}
        disabled={disabled}
      >
        <Button size="large" className="upload-btn">
       
          {buttonText}
        </Button>
      </Upload>

      {/* Custom inline list under the field */}
      {fileList?.length > 0 && (
        <div style={{ marginTop: 8 }}>
          {fileList.map((f, i) => (
            <div
              key={f.uid || f.name + i}
              className="file-row"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                background: "#fafafa",
                borderRadius: 6,
                padding: "8px 12px",
                border: "1px solid #f0f0f0",
                marginBottom: 8,
              }}
            >
              <span className="file-row-name" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                {f.name}
              </span>
              <Button
                type="text"
                className="file-row-delete"
                icon={<DeleteOutlined />}
                onClick={() => removeAt(i)}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
